
export default {
  props: {
    faqList: {
      type: Array,
    },
  },
  data() {
    return {
      faq: [0],
    };
  },
  watch: {
    faqList: {
      handler(newValue) {
        if (newValue) {
          this.faq = [0];
        }
      },
      deep: true,
    },
  },
  methods: {
    openAnswer(index) {
      if (this.faq.includes(index)) {
        const faqIndex = this.faq.indexOf(index);
        this.faq.splice(faqIndex, 1);
      } else {
        this.faq.push(index);
      }
    },
  },
};
